
export const ReactionFilterOption = {
    AllReactions : 0,
    InvitationReactions : 3,
    RejectReactions : 2,
    ViewReactions : 1,
    NotViewReactions : 4
}